export class Company {
    constructor({
                    //attributes
                    id= null,
                    name= "",
                    trade= "",
                    type= 'store',
                    email= '',
                    urlkey= '',
                    group= null,
                    hq= null,
                    pivot= null,
                    settings= null,
                    subscription= null,
                    extradata= null,
                    hasErpIntegration= null,
                    erpInfo= null,
                    webhook_info= null,
                    observation = null,
                    vindi_id= null,
                    cnpj= null,
                    superlogica_id= null,
                    blocked= null,
                    overdue= null,
                    responsible_id= null,
                    users= [],
                    images= [],
                    phones= [],
                    addresses= [],
                    extra_info_client=[],
                    extra_info_architect=[],
                    related_labels=[],
                    extra_info_office=[],
                    extra_info_product=[],
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    isHq = null,
                    purchase_orders_enabled= 0
                } = {}) {
        //fill attributes
        //Object.keys(arguments[0]).forEach(att=>this[att]=arguments[0][att]);
        this.id=id;
        this.name=name;
        this.trade=trade;
        this.cnpj=cnpj;
        this.type=type;
        this.email=email;
        this.urlkey=urlkey;
        this.group=group;
        this.pivot=pivot;
        this.settings=settings;
        this.subscription=subscription;
        this.extradata=extradata;
        this.hasErpIntegration=hasErpIntegration;
        this.erpInfo=erpInfo||{};
        this.webhook_info=webhook_info||{};
        this.vindi_id=vindi_id;
        this.superlogica_id=superlogica_id;
        this.blocked=blocked;
        this.overdue=overdue;
        this.users=users;
        this.images=images;
        this.phones=phones;
        this.addresses=addresses;
        this.extra_info_client=extra_info_client;
        this.extra_info_architect=extra_info_architect;
        this.extra_info_office=extra_info_office;
        this.extra_info_product=extra_info_product;
        this.related_labels=related_labels;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;
        this.responsible_id=responsible_id;
        this.isHq=isHq;
        this.purchase_orders_enabled=purchase_orders_enabled;


        if(this.hq)
            this.hq = new Company(hq||{});
        else
            this.hq = null;

    }

    shareWithBranches(resource){
        return this.hq && this.hq.settings.branches && this.hq.settings.branches[resource]===true;
    }

    getClientsCompanyId(){
        if(this.shareWithBranches('share_clients')){
            return this.hq.id;
        }else{
            return this.id;
        }
    }

    getProductsCompanyId(){
        if(this.shareWithBranches('share_products')){
            return this.hq.id;
        }else{
            return this.id;
        }
    }

    usesHQProducts(){
        return this.shareWithBranches('share_products');
    }

    hasPaymentMethodsIntegration(){
        return ['bling', 'bling_v2', 'tinyerp'].includes(this.erpInfo.name);
    }

    usesErpPaymentMethods(){
        if(this.id==32564)
            return true;
        return this.hasPaymentMethodsIntegration() && !!this.erpInfo.use_erp_payment_methods;
    }

    locksPaymentMethods(){
        return this.usesErpPaymentMethods()
            || !!(this.webhook_info && this.webhook_info.has_payment_method_webhook);
    }

    isStore(){
        return this.type ==='store';
    }

    hasAdsAccount(type="GoogleAds"){
        let adsType = type === "GoogleAds" ? "Googleads" : "Faceads";
        return !!this.settings.Ads && !!this.settings.Ads[adsType] && this.settings.Ads[adsType].adAccount
    }

    erpName(){
        return this.erpInfo.name || '';
    }
}

export function createCompany(data={}) {
    return Object.freeze(new Company(data));
}